// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"f6d25adc","375":"018a7067","787":"3b46f87a"}[chunkId] + ".chunk.js";
};